import { Editor } from '@lumapps/wrex/slate';
import type { Wrex } from '@lumapps/wrex/types';

import type { IsTextualBlock } from './createTextualBlockKeyHandler';

/**
 * Shared `insertSoftBreak` behavior for textual blocks: Shift+Enter inside the block inserts a line
 * break instead of splitting the block. Falls back to the default `insertSoftBreak` (`next`) elsewhere.
 *
 * @example
 * insertSoftBreak() {
 *     insertTextualBlockSoftBreak(editor, isCodeBlock, insertSoftBreak);
 * }
 */
export const insertTextualBlockSoftBreak = (editor: Editor, isBlock: IsTextualBlock, next: () => void): void => {
    if (editor.selection) {
        const parentEntry = Editor.parent(editor, editor.selection);
        if (parentEntry && isBlock(parentEntry[0] as Wrex.Element)) {
            editor.insertText('\n');
            return;
        }
    }
    next();
};
